/**
 * Use this helper method whenever you use methods that
 * takes an item of an array and returns true when all keys
 * in keyValue and items are equal.
 *
 * Examples:
 *  - someArray.find(byProperties({id:'someid'}));
 *  - someArray.filter(byProperties({type:'someType', color:'red'}));
 */
export const byProperties = <T extends U, U>(keyValues: Partial<T>) => (
  item: U,
) => Object.keys(keyValues).every((key) => item[key] === keyValues[key]);
